import styled from "styled-components";
import { Colors } from "@tvg/design-system";

export const ButtonContainer = styled.div<{
  isActive?: boolean;
}>`
  display: flex;
  flex-shrink: 0;
  border-radius: 4px;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  flex-direction: column;
`;

export const StyledButton = styled.button<{
  isActive: boolean;
  colors: Colors;
}>`
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: space-between;
  height: 48px;
  padding: 0 12px;
  border: none;
  border-bottom: 1px solid ${({ colors }) => colors.blue["100"]};
  background-color: ${({ colors }) => colors.white["900"]};
`;

export const FooterButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;

  > button {
    font-size: 16px;
  }
`;
